
<div class='selector'>
  <div class='selector-container'>
    <div class='selector-arrow selector-arrow_left' @click='moveToPreviousDay(true)'></div>
    <div class="selector-txt-container selector-txt-calendar" @click='showVisibilityCalendar()'>
      <div class='selector-ico'>
        <div class='selector-ico-calendar'></div>
      </div>
      <div class='selector-txt'>
        <div id='dateToPrint' class='selector-txt-normal'>
          {{ getCurrentDateLinear }}
        </div>
        <div class='selector-txt-short'>
          {{ getCurrentDateLinearShort }}
        </div>
      </div>
    </div>
    <div class='selector-arrow selector-arrow_right' @click='moveToNextDay(true)'></div>
  </div>
</div>
